import React, { useState, useEffect } from "react";
import PropertyCardAdmin from "./PropertyCardAdmin";

export const API_URL = process.env.REACT_APP_API_URL;

const PropertyForm = ({ property, onCreated }) => {
  const [form, setForm] = useState({
    title: "",
    type: "",
    location: "",
    price: "",
    area: "",
    bedrooms: "",
    bathrooms: "",
    parking: "",
    description: "",
    highlights: [],
    nearbyPlaces: [],
    featured: false,
  });

  // Estado único de imágenes: puede contener strings (URLs) o File (subidas)
  const [allImages, setAllImages] = useState([]);
  const [showDetails, setShowDetails] = useState(false);

  // Cargar propiedad si se edita
  useEffect(() => {
    if (property) {
      setForm({
        ...property,
        highlights: property.highlights || [],
        nearbyPlaces: property.nearbyPlaces || [],
      });
      setAllImages(property.images || []);
      setShowDetails(false);
    } else {
      setForm({
        title: "",
        type: "",
        location: "",
        price: "",
        area: "",
        bedrooms: "",
        bathrooms: "",
        parking: "",
        description: "",
        highlights: [],
        nearbyPlaces: [],
        featured: false,
      });
      setAllImages([]);
      setShowDetails(false);
    }
  }, [property]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleArrayChange = (field, value) => {
    setForm({
      ...form,
      [field]: value.split("\n").filter(Boolean),
    });
  };

  const handleNewImages = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
  };

  const handleImagesChange = (newImages) => {
    setAllImages(newImages);
  };

  const submit = async (e) => {
    e.preventDefault();

    const data = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      if (key === "images") return;
      if (Array.isArray(value)) value.forEach((v) => data.append(key, v));
      else data.append(key, value);
    });

    // Separar archivos nuevos de URLs existentes
    allImages.forEach((img) => {
      if (img instanceof File) data.append("images", img);
      else data.append("existing_images", img);
    });

    const url = property
      ? `${API_URL}/inmogar/admin/properties/${property.id}`
      : `${API_URL}/inmogar/admin/properties`;
    const method = property ? "PUT" : "POST";

    try {
      await fetch(url, { method, body: data });
      alert(property ? "Propiedad actualizada" : "Propiedad creada");
      onCreated();
    } catch (err) {
      console.error(err);
      alert("Error al guardar la propiedad");
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

      {/* FORMULARIO */}
      <form className="max-w-3xl mx-auto bg-white shadow-lg rounded-xl p-8 space-y-6" onSubmit={submit}>
        <h2 className="text-2xl font-bold text-[#1e3a5f]">
          {property ? "Editar Propiedad" : "Nueva Propiedad"}
        </h2>

        {/* Campos principales */}
        <div className="grid md:grid-cols-2 gap-4">
          {["title", "type", "location", "price", "area", "bedrooms", "bathrooms", "parking"].map((field) => (
            <div key={field}>
              <label className="label">{field.charAt(0).toUpperCase() + field.slice(1)}</label>
              <input
                className="input"
                type={["price","area","bedrooms","bathrooms","parking"].includes(field) ? "number" : "text"}
                name={field}
                value={form[field]}
                onChange={handleChange}
              />
            </div>
          ))}
        </div>

        {/* Descripción */}
        <div>
          <label className="label">Descripción</label>
          <textarea className="input h-28" name="description" value={form.description} onChange={handleChange} />
        </div>

        {/* Highlights y lugares cercanos */}
        <div>
          <label className="label">Highlights (uno por línea)</label>
          <textarea
            className="input h-24"
            value={form.highlights.join("\n")}
            onChange={(e) => handleArrayChange("highlights", e.target.value)}
          />
        </div>

        <div>
          <label className="label">Lugares cercanos (uno por línea)</label>
          <textarea
            className="input h-24"
            value={form.nearbyPlaces.join("\n")}
            onChange={(e) => handleArrayChange("nearbyPlaces", e.target.value)}
          />
        </div>

        {/* Subir imágenes nuevas */}
        <div>
          <label className="label">Imágenes de la propiedad</label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleNewImages}
            className="block w-full text-sm text-gray-600
              file:mr-4 file:py-2 file:px-4
              file:rounded-lg file:border-0
              file:bg-[#7cb342] file:text-white
              hover:file:bg-[#689f2f]"
          />
        </div>

        {/* Destacada */}
        <label className="flex items-center gap-2">
          <input type="checkbox" name="featured" checked={form.featured} onChange={handleChange} />
          Propiedad destacada
        </label>

        <button
          type="submit"
          className="w-full bg-[#7cb342] hover:bg-[#689f2f] text-white py-3 rounded-lg font-semibold transition"
        >
          {property ? "Actualizar Propiedad" : "Guardar Propiedad"}
        </button>
      </form>

      {/* VISTA PREVIA */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Vista previa</h3>
        <PropertyCardAdmin
          property={{ ...form, images: allImages, currency: "S/" }}
          onViewDetails={() => setShowDetails(!showDetails)}
          detailed={showDetails}
          onImagesChange={handleImagesChange}
        />
      </div>
    </div>
  );
};

export default PropertyForm;